// Shared scaffold for full-screen error states. Prefix: elo-.
// The BaseCard is a fixed 636×520 hero; the logo is pinned to the top, the
// error block is centered in the flexible middle (.elo-main flex:1), and the
// footer sits at the bottom — so no error state leaves a large empty void the
// way the old per-screen `margin:auto` layouts did.
export const errorLayoutStyles = `
  .elo-logo {
    height: 4.25rem;
    width: 100%;
    max-width: 15rem;
    object-fit: contain;
    margin: 0 auto;
    flex-shrink: 0;
  }
  .elo-main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-6);
    padding: var(--space-5) 0;
  }
  .elo-action {
    display: flex;
    justify-content: center;
  }
  .elo-footer {
    flex-shrink: 0;
    margin-top: auto;
    padding-top: var(--space-2);
  }
`;
